<template>
  <ul class="rating-overall">
    <li
      class="rating-overall__box"
      :class="{
        'rating-overall__box--active': modelValue === 2
      }"
      @click="emitEvent(2)"
      @touchdown="emitEvent(2)"
    >
      <div
        class="rating-overall__icon rating-overall__icon--smile icon-smile-perfectly"
      />

      <div v-if="showDescription" class="rating-overall__description">
        {{ $t('seller.perfect') }}
      </div>
    </li>

    <li
      class="rating-overall__box"
      :class="{
        'rating-overall__box--active': modelValue === 1
      }"
      @click="emitEvent(1)"
      @touchdown="emitEvent(1)"
    >
      <div
        class="rating-overall__icon rating-overall__icon--meh icon-smile-satisfactorily"
      />
      <div v-if="showDescription" class="rating-overall__description">
        {{ $t('seller.passably') }}
      </div>
    </li>

    <li
      class="rating-overall__box"
      :class="{
        'rating-overall__box--active': modelValue === 0
      }"
      @click="emitEvent(0)"
      @touchdown="emitEvent(0)"
    >
      <div
        class="rating-overall__icon rating-overall__icon--frown icon-smile-badly"
      />

      <div v-if="showDescription" class="rating-overall__description">
        {{ $t('seller.bad') }}
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
type Props = {
  /**
   * null - empty
   * 0 - bad
   * 1 - passably
   * 2 - perfect
   */
  modelValue: number | null
  hideDescription?: boolean
}
type Emits = {
  (e: 'update:modelValue', value: number): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const showDescription = computed(() => {
  return !props.hideDescription
})

const emitEvent = (value: number) => {
  emit('update:modelValue', value)
}

</script>

<style lang="scss" scoped>
.rating-overall {
  $root: &;
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;

  &__box {
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    margin-right: 3rem;
    &:last-of-type {
      margin-right: 0;
    }

    &--active {
      opacity: 1;
      #{$root}__icon {
        &--frown {
          color: $error-color;
        }

        &--meh {
          color: $secondary-font-color;
        }

        &--smile {
          color: $font-accent-color;
        }
      }
    }
  }

  &__icon {
    text-align: center;
    font-size: 3.5rem;
    color: #d3d3d3;
  }

  &__description {
    margin-top: 0.6rem;
    text-align: center;
    text-transform: capitalize;
  }
}
</style>
